import { FC } from 'react';
import { TypeBody } from '../Typography';
import Button, { ButtonProps } from '../Button';
import { Container } from 'styled/layouts/container';
import {
  HeadlineWrapper,
  HeadlineContainer,
  HeadlineContent,
  HeadlineTitle,
} from './headline.styled';

export type variants = 'left' | 'center' | '50-50';

interface HeadlineProps {
  title: string | React.ReactNode;
  body?: string;
  primaryButton?: ButtonProps;
  variant: variants;
  wrapperType?: string;
  contentMaxInlineSize?: string;
  titleMaxInlineSize?: string;
}

const Headline: FC<HeadlineProps> = ({
  title,
  body,
  primaryButton,
  variant,
  wrapperType = 'section',
  contentMaxInlineSize,
  titleMaxInlineSize,
}) => {
  return (
    <HeadlineWrapper as={wrapperType ?? 'section'}>
      <Container>
        <HeadlineContainer variant={variant}>
          <HeadlineTitle $titleMaxInlineSize={titleMaxInlineSize}>
            {title}
          </HeadlineTitle>
          <HeadlineContent
            $contentMaxInlineSize={contentMaxInlineSize}
            variant={variant}
          >
            {body && <TypeBody>{body}</TypeBody>}
            {primaryButton && (
              <Button label={primaryButton?.label} url={primaryButton?.url} />
            )}
          </HeadlineContent>
        </HeadlineContainer>
      </Container>
    </HeadlineWrapper>
  );
};

export default Headline;
